export default __webpack_public_path__ + "3861ade0752f068c7bd568e21832816e.svg";